import { render, staticRenderFns } from "./MessagingModeSwitcher.vue?vue&type=template&id=a2038578&scoped=true&"
import script from "./MessagingModeSwitcher.vue?vue&type=script&lang=js&"
export * from "./MessagingModeSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./MessagingModeSwitcher.vue?vue&type=style&index=0&id=a2038578&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2038578",
  null
  
)

export default component.exports